import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { AddUserComponent } from './pages/add-user/add-user.component';
import { EditUserComponent } from './pages/edit-user/edit-user.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';

const routes: Route[] = [
  {
    path: '',
    component: UserManagementComponent,
  },
  {
    path: 'add',
    component: AddUserComponent,
  },
  {
    path: ':id/edit',
    component: EditUserComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule {}
